import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTariffCalls } from '../../tariff-detail/hooks/useTariffCalls'
import { setLoading, setComunidadesData } from '../slices/comunidades.slice'

export const useComunidades = () => {
  const dispatch = useDispatch()
  const { entities, isLoading, error, loadedEmpresaId } = useSelector((state) => state.comunidades)
  const { getEmpresaZonasPeticionesOp } = useTariffCalls()

  const loadComunidades = useCallback(
    (empresaId) => {
      if (loadedEmpresaId === empresaId) return

      dispatch(setLoading(true))
      getEmpresaZonasPeticionesOp(empresaId).then(({ data }) =>
        dispatch(setComunidadesData({ data, empresaId }))
      )
    },
    [dispatch, getEmpresaZonasPeticionesOp, loadedEmpresaId]
  )

  return {
    comunidades: entities,
    isLoading,
    error,
    loadComunidades,
  }
}
